import { type RefObject, useEffect } from 'react';

export function useClickOutside(cb: () => void, ref: RefObject<HTMLElement | null>, open: boolean, deps: any[] = []) {

  useEffect(() => {
    
    const handleClick = (event: globalThis.MouseEvent) => {
      const rect = ref.current?.getBoundingClientRect();
      if (rect && (event.x < rect.x || event.x > rect.right || event.y < rect.y || event.y > rect.bottom)) {
        setTimeout(() => {
          cb();
        }, 25);
      }
    };

    if (open) {
      document.addEventListener('click', handleClick, { capture: true });
    } else {
      document.removeEventListener('click', handleClick, { capture: true });
    }

    return () => {
      document.removeEventListener('click', handleClick, { capture: true });
    };
  }, [cb, open, ...deps]);
}
